import FAQAccordion from '@/components/base/FAQAccordion';
import { faqItems } from '@/mocks/faqData';

export default function FAQSection() {
  return (
    <section className="relative bg-background-50 py-20 md:py-28">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-5xl mx-auto flex flex-col lg:flex-row gap-12 lg:gap-16">
          <div className="flex-1 lg:max-w-md">
            <span className="inline-flex items-center gap-2 text-xs tracking-widest uppercase text-accent-600 font-medium">
              <span className="w-2 h-2 rounded-full bg-foreground-900"></span>
              FAQ
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-semibold text-foreground-950 mt-4 leading-tight">
              &ldquo;Everything you need to know about Litbuy Spreadsheet&rdquo;
            </h2>
            <div className="mt-6 flex items-center gap-3">
              <span className="text-sm font-semibold text-foreground-900">Litbuy Team</span>
              <span className="w-5 h-5 flex items-center justify-center rounded-full bg-accent-200">
                <i className="ri-check-line text-accent-700 text-xs"></i>
              </span>
            </div>

            <div className="mt-10 hidden lg:block">
              <div className="relative w-48 h-48 rounded-xl overflow-hidden bg-secondary-100">
                <img
                  src="https://readdy.ai/api/search-image?query=Minimalist%20office%20desk%20with%20spreadsheet%20documents%20and%20coffee%2C%20warm%20cream%20background%2C%20soft%20natural%20lighting%2C%20modern%20workspace%20still%20life%2C%20professional%20editorial%20photography%2C%20clean%20organized%20composition%2C%20no%20person&width=600&height=600&seq=faq-portrait-litbuy-v2&orientation=squarish"
                  alt="Litbuy Spreadsheet support"
                  className="w-full h-full object-cover object-top"
                  title="Litbuy Spreadsheet FAQ support"
                />
              </div>
            </div>
          </div>

          <div className="flex-1 lg:max-w-xl">
            <FAQAccordion items={faqItems} />
          </div>
        </div>
      </div>
    </section>
  );
}